import { FC, lazy } from 'react';

const Page = lazy(() => import('./page'));

export const FCFSBookingWizard: FC = () => {
  return <Page />;
};
